/** Both magnet formats use the same photo proportions, including the bleed. */
const PORTRAIT_MAGNET_CROP_RATIO = 107 / 158;

export interface ZalamoMagnetAutoCrop {
  /** Percentage coordinates in [x, y, width, height] order, used by the basket. */
  xywh: [number, number, number, number];
  /** Percentage margins in [top, right, bottom, left] order, used by the editor. */
  margins: [number, number, number, number];
}

export const getZalamoMagnetCropRatio = (imageRatio: number): number =>
  // Match production rendering: square source photos are portrait.
  imageRatio > 1 ? 1 / PORTRAIT_MAGNET_CROP_RATIO : PORTRAIT_MAGNET_CROP_RATIO;

export function calculateZalamoMagnetAutoCrop(
  imageRatio: number,
): ZalamoMagnetAutoCrop {
  if (!Number.isFinite(imageRatio) || imageRatio <= 0) {
    return { xywh: [0, 0, 100, 100], margins: [0, 0, 0, 0] };
  }

  const targetRatio = getZalamoMagnetCropRatio(imageRatio);
  const width =
    imageRatio > targetRatio ? (targetRatio / imageRatio) * 100 : 100;
  const height =
    imageRatio > targetRatio ? 100 : (imageRatio / targetRatio) * 100;
  const left = (100 - width) / 2;
  const top = (100 - height) / 2;

  return {
    xywh: [left, top, width, height],
    margins: [top, left, top, left],
  };
}
